var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"profile-upload"}},[_c('div',{staticClass:"user flex justify-center"},[_c('input',{ref:"file",attrs:{"type":"file","id":"upload-photo"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_c('label',{staticClass:"upload-picture",attrs:{"for":"upload-photo"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }